<template>
  <div class="dialog-edit-store-app-wrapper">
    <el-dialog title="修改应用" width="70%" :visible="visible" @open="onDialogOpen" @close="onDialogClose">

      <el-form label-position="top" ref="form" class="form" :rules="formRules" :model="form">

        <!--<el-form-item label="模块名称（用于前端显示）" prop="app_module_name">-->
          <!--<el-input v-model="form.app_module_name" />-->
        <!--</el-form-item>-->

        <el-form-item
          v-for="(i18n, index) in form.app_name_i18n"
          :key="'i18n' + index"
          :label="'国际化名称' + index" >
          <el-input
            class="inline-item"
            style="width: 45%;"
            v-model="i18n.lang"
            placeholder="请输入地区代码" />
          <el-input
            class="inline-item"
            style="width: 45%;"
            v-model="i18n.name"
            placeholder="请输入应用国际化名称" />
          <el-button
            type="danger"
            size="mini"
            @click="onNameI18nDelete(index)">删除</el-button>
        </el-form-item>

        <el-form-item
          v-for="(pac, index) in form.package"
          :key="'package' + index"
          :label="'套餐' + index" >
          <el-input
            class="inline-item"
            style="width: 16%;"
            v-model="pac.name"
            placeholder="请输入套餐名称" />
          <el-input
            class="inline-item"
            style="width: 16%;"
            type="number"
            v-model="pac.market_price"
            placeholder="请输入市场价格" />
          <el-input
            class="inline-item"
            style="width: 16%;"
            type="number"
            v-model="pac.discount_price"
            placeholder="请输入折扣价格" />
          <el-input
            class="inline-item"
            style="width: 16%;"
            type="number"
            v-model="pac.duration"
            v-if="pac.time_step !== 'forever'"
            placeholder="请输入有效时间" />
          <el-select
            class="inline-item"
            style="width: 18%;"
            default-first-option
            v-model="pac.time_step">
            <el-option label="秒" value="second" />
            <el-option label="分钟" value="minute" />
            <el-option label="小时" value="hour" />
            <el-option label="天" value="day" />
            <el-option label="周" value="week" />
            <el-option label="月" value="month" />
            <el-option label="年" value="year" />
            <el-option label="永久" value="forever" />
          </el-select>
          <el-button
            type="danger"
            size="mini"
            @click="onPackageDelete(index)">删除</el-button>
        </el-form-item>

        <el-form-item label="是否公开" prop="is_publish" >
          <el-radio v-model="form.is_publish" :label="0">不公开</el-radio>
          <el-radio v-model="form.is_publish" :label="1">公开</el-radio>
        </el-form-item>

        <el-form-item label="应用分类" prop="app_category_id">
          <el-select
            filterable
            default-first-option
            placeholder="请选择应用类型"
            v-model="form.app_category_id">
            <el-option
              v-for="category in appCategoryList"
              :key="category.app_category_id"
              :label="category.app_category_name_i18n[0].name"
              :value="category.app_category_id" />
          </el-select>
        </el-form-item>

        <el-form-item label="应用类型" prop="app_type" >
          <el-radio v-model="form.app_type" label="user">用户</el-radio>
          <el-radio v-model="form.app_type" label="agent">代理商</el-radio>
        </el-form-item>

        <el-form-item label="应用介绍" prop="intro">
          <el-input type="textarea" v-model="form.intro" />
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="form.remarks" />
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onFormSubmit">确定</el-button>
          <el-button type="info" @click="onNameI18nAdd">添加国家化名称</el-button>
          <el-button type="info" @click="onPackageAdd">添加套餐</el-button>
          <el-button @click="onFormCancel">取消</el-button>
        </el-form-item>

      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'DialogEditStoreApp',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    editingApp: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      formRules: {
        // app_module_name: [
        //   { required: true, message: '请输入模块名称', trigger: 'blur' }
        // ],
        app_category_id: [
          { required: true, message: '请选择应用分类标签', trigger: 'change' }
        ],
        intro: [
          { required: true, message: '请输入模块介绍信息', trigger: 'blur' }
        ]
      },
      form: {
        app_store_id: 0,
        app_module_name: '',
        app_name_i18n: [
          {
            name: '',
            lang: ''
          }
        ],
        package: [
          {
            name: '',
            market_price: '',
            discount_price: '',
            duration: '',
            time_step: 'forever'
          }
        ],
        is_publish: 0,
        app_category_id: '',
        app_type: 'user',
        intro: '',
        remarks: ''
      }
    }
  },
  computed: {
    ...mapState('store', [
      'appCategoryList'
    ])
  },
  methods: {
    ...mapActions('store', [
      'getAppCategories',
      'editApp'
    ]),

    onNameI18nAdd () {
      this.form.app_name_i18n.push({
        name: '',
        lang: ''
      })
    },
    onPackageAdd () {
      this.form.package.push({
        name: '',
        market_price: '',
        discount_price: '',
        duration: '',
        time_step: 'forever'
      })
    },
    onNameI18nDelete (index) {
      if (this.form.app_name_i18n.length <= 1) {
        this.$message({
          type: 'error',
          message: '至少需要包含一个国际化名称'
        })
        return
      }
      this.form.app_name_i18n.splice(index, 1)
    },
    onPackageDelete (index) {
      if (this.form.package.length <= 1) {
        this.$message({
          type: 'error',
          message: '至少需要包含一个套餐'
        })
        return
      }
      this.form.package.splice(index, 1)
    },

    // 整理表单，验证数据
    cleanFormAndSubmit () {
      const clean = JSON.parse(JSON.stringify(this.form))

      // 检查国家化名称字段信息
      for (let i = 0; i < clean.app_name_i18n.length; i++) {
        const i18n = clean.app_name_i18n[i]
        if (i18n.lang === '' || i18n.name === '') {
          this.$message({
            type: 'error',
            message: '请输入国际化名称'
          })
          return
        }
      }

      // 检查套餐字段信息
      for (let i = 0; i < clean.package.length; i++) {
        const pac = clean.package[i]

        if (pac.name === '' || pac.market_price === '' || pac.discount_price === '') {
          this.$message({
            type: 'error',
            message: '请输入套餐相关信息'
          })
          return
        }
        if (pac.time_step !== 'forever' && pac.duration === '') {
          this.$message({
            type: 'error',
            message: '请输入套餐相关信息'
          })
          return
        }

        // 转化价格格式
        pac.market_price = parseInt(parseFloat(pac.market_price) * 100)
        pac.discount_price = parseInt(parseFloat(pac.discount_price) * 100)

        // 计算过期时间
        switch (pac.time_step) {
          case 'second':
            pac.duration = parseInt(pac.duration)
            break
          case 'minute':
            pac.duration = parseInt(pac.duration) * 60
            break
          case 'hour':
            pac.duration = parseInt(pac.duration) * 3600
            break
          case 'day':
            pac.duration = parseInt(pac.duration) * 86400
            break
          case 'week':
            pac.duration = parseInt(pac.duration) * 604800
            break
          case 'month':
            pac.duration = parseInt(pac.duration) * 2592000
            break
          case 'year':
            pac.duration = parseInt(pac.duration) * 31536000
            break
          default:
            pac.duration = 3153600000
        }
        delete pac.time_step

        if (isNaN(pac.duration)) {
          this.$meesage({
            type: 'error',
            message: '请输入合法的套餐过期时间'
          })
          return
        }
        clean.package[i] = pac
      }

      // 提交表单
      this.performSubmit(clean)
    },
    async performSubmit (cleanForm) {
      try {
        await this.editApp(cleanForm)

        this.$emit('update:visible', false)
        this.$emit('data-change')
      } catch (err) {
        this.$message({
          type: 'error',
          message: '修改应用失败'
        })
        console.log(err)
      }
    },

    onFormSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.cleanFormAndSubmit()
        }
      })
    },
    onFormCancel () {
      this.$emit('update:visible', false)
    },

    onDialogOpen () {
      this.form.app_store_id = this.editingApp.app_store_id
      this.form.app_module_name = this.editingApp.app_module_name || ''
      this.form.app_name_i18n = this.editingApp.app_name_i18n
      this.form.is_publish = this.editingApp.is_publish || 1
      this.form.app_category_id = this.editingApp.app_category_detail.app_category_id
      this.form.app_type = this.editingApp.app_type || 'user'
      this.form.intro = this.editingApp.intro
      this.form.remarks = ''

      this.form.package = []
      for (let i = 0; i < this.editingApp.package.length; i++) {
        const addingPackage = JSON.parse(JSON.stringify(this.editingApp.package[i]))
        addingPackage.market_price = (parseFloat(addingPackage.market_price) / 100).toFixed(2)
        addingPackage.discount_price = (parseFloat(addingPackage.discount_price) / 100).toFixed(2)

        this.form.package.push({
          ...addingPackage,
          time_step: 'second'
        })
      }
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/sass/base.scss';

.dialog-add-store-app-wrapper {

  .inline-item {
    margin-right: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/store/components/DialogEditStoreApp.vue